import { lazy } from 'react';
import { adaptiveCenterModalOptions } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const AnyVideoClipsPageContent = lazy(
  () => import('./AnyVideoClipsPageContent'),
);

const AnyVideoClipsPage = wrapLazyNavigatorScreen(
  AnyVideoClipsPageContent,
  adaptiveCenterModalOptions(),
);

export default AnyVideoClipsPage;
